import type { Step } from '../components/navigation/Stepper';

// Step ids double as the route segment under /patient/creation/:id/.
const ALL_STEPS: Step[] = [
    { id: 'patient-details', label: 'Patient Details', backLabel: 'All patients' },
    { id: 'case-type', label: 'Case Type', backLabel: 'Patient details' },
    { id: 'sub-case-type', label: 'Select approach', backLabel: 'Case type' },
    { id: 'tp-review', label: 'Review', backLabel: 'Approach' },
    { id: 'photos', label: 'Upload photos', backLabel: 'Treatment review' },
    { id: 'stls', label: 'Upload STLs', backLabel: 'Photos' },
    { id: 'order', label: 'Order', backLabel: 'STLs' }
];

// ODO prefills the case type and approach server-side for V2 practices.
const V2_SKIPPED_STEP_IDS = ['case-type', 'sub-case-type'];

const V2_STEPS: Step[] = ALL_STEPS.filter((step) => !V2_SKIPPED_STEP_IDS.includes(step.id)).map(
    (step) => (step.id === 'tp-review' ? { ...step, backLabel: 'Patient details' } : step)
);

export function buildPatientCreationSteps(isV2: boolean): Step[] {
    return isV2 ? V2_STEPS : ALL_STEPS;
}

export function getPathSegment(pathname: string): string {
    return pathname.split('/').filter(Boolean).pop() ?? '';
}

// A step missing from `steps` resolves to the next step that is in it.
export function getStepIndexFromPath(steps: Step[], pathname: string): number {
    const segment = getPathSegment(pathname);
    const index = steps.findIndex((step) => step.id === segment);
    if (index >= 0) return index;

    const fullIndex = ALL_STEPS.findIndex((step) => step.id === segment);
    if (fullIndex < 0) return 0;
    const laterIds = ALL_STEPS.slice(fullIndex + 1).map((step) => step.id);
    return Math.max(
        0,
        steps.findIndex((step) => laterIds.includes(step.id))
    );
}

export function getPathFromStep(steps: Step[], stepIndex: number, id: string): string {
    const step = steps[stepIndex] ?? steps[0];
    return `/patient/creation/${id}/${step.id}`;
}
